import { TableBody } from '@mui/material';
import React from 'react';

import ArtworkRow from './components/ArtworkRow';

const TableArtistShowAllBody = ({ listArtwork }) => {
  return (
    <TableBody>
      {(listArtwork || []).map((artwork, index) => (
        <ArtworkRow
          key={index}
          artwork={artwork}
        />
      ))}
    </TableBody>
  );
};

export default TableArtistShowAllBody;
